import React, { Component } from 'react';
import qs from 'query-string';
import classNames from 'classnames';
import { REACT_APP_API_BASE } from '../../config';
import withAuthProvider from '../../hoc/withAuthProvider';
import withFetch from '../../hoc/withFetch';
import Heading from '../../components/heading';
import NotificationList from '../../components/notificationlist';
import SpinnerDots from '../../components/spinner/dots';
import './styles.scss';
const HITS_PER_PAGE = 10;

class Notifications extends Component {
    
    state = {
        isLoading: true,
        notifications: null
    };

    async fetchNotifications(page) {
        const skip = !isNaN(parseInt(page)) ? (parseInt(page)-1) * HITS_PER_PAGE : 0;

        const res = await this.props.fetch(`${REACT_APP_API_BASE}/online/notifications?skip=${skip}&take=${HITS_PER_PAGE}`);

        if (res.ok) {
            return await res.json();
        }
    }

    async componentDidUpdate(prevProps) {
        if (!this.props.isAuthenticated) return;

        const { location } = this.props;
        const query = qs.parse(location.search);
        const prevQuery = qs.parse(prevProps.location.search);

        if (query.page !== prevQuery.page && !this.state.isLoading) {
            this.setState({
                isLoading: true
            });

            const notifications = await this.fetchNotifications(query.page);

            this.setState({
                isLoading: false,
                notifications: {
                    ...notifications,
                    notifications: [...this.state.notifications.notifications, ...notifications.notifications]
                }
            });
        } 

        if (this.state.notifications) return;

        const notifications = await this.fetchNotifications(query.page);
        
        this.setState({
            isLoading: false,
            notifications
        });

        //if (this.state.notifications) return;


        /*const notifications = await this.fetchNotifications();
        
        this.setState({
            isLoading: false,
            notifications
        });*/
    }

    render() {

        const { location } = this.props;
        const query = qs.parse(location.search);

        return (
            <section className={classNames({
                'notifications': true,
                'notifications--is-loading': this.state.isLoading
            })}>
                <Heading heading="Notifieringar" modifiers={{
                    'page-header--stack':  true
                }}></Heading>
                <NotificationList notifications={this.state.notifications} page={query.page ? query.page : 1} />
                <SpinnerDots />
            </section>
        );
    }
};

export default withAuthProvider(withFetch(Notifications));